import ApiAuth from './ApiAuth'


export const Documents = {
    deleteFile(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().delete(`brand/${data.brandId}/document/${data.documentId}`, data.data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        })
    },
    editFile(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().put(`brand/${data.id}/document/${data.fileId}`, data.data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response)
            });
        });
    }
};
